window.addEventListener('DOMContentLoaded', event => {
  // Activate feather
  feather.replace();

  // Enable tooltips globally
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Enable popovers globally
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl);
  });

  // Toggle the side navigation
  const sidebarToggle = document.body.querySelector('#sidebarToggle');
  if (sidebarToggle) {
      // Uncomment Below to persist sidebar toggle between refreshes
      // if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
      //     document.body.classList.toggle('sidenav-toggled');
      // }
      sidebarToggle.addEventListener('click', event => {
          event.preventDefault();
          document.body.classList.toggle('sidenav-toggled');
          localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sidenav-toggled'));
      });
  }

  // Close side navigation when width < LG
  const sidenavContent = document.body.querySelector('#layoutSidenav_content');
  if (sidenavContent) {
      sidenavContent.addEventListener('click', event => {
          const BOOTSTRAP_LG_WIDTH = 992;
          if (window.innerWidth >= 992) {
              return;
          }
          if (document.body.classList.contains("sidenav-toggled")) {
              document.body.classList.toggle("sidenav-toggled");
          }
      });
  }

  // Add active state to sidbar nav links
  let activatedPath = window.location.pathname.match(/([\w-]+\.html)/, '$1');

  if (activatedPath) {
      activatedPath = activatedPath[0];
  } else {
      activatedPath = 'index.html';
  }

  const targetAnchors = document.body.querySelectorAll('[href="' + activatedPath + '"].nav-link');

  targetAnchors.forEach(targetAnchor => {
      let parentNode = targetAnchor.parentNode;
      while (parentNode !== null && parentNode !== document.documentElement) {
          if (parentNode.classList.contains('collapse')) {
              parentNode.classList.add('show');
              const parentNavLink = document.body.querySelector(
                  '[data-bs-target="#' + parentNode.id + '"]'
              );
              parentNavLink.classList.remove('collapsed');
              parentNavLink.classList.add('active');
          }
          parentNode = parentNode.parentNode;
      }
      targetAnchor.classList.add('active');
  });
});


//ここからchat page script
// カテゴリーボタンにイベントリスナーを追加
const categoryButtons = document.querySelectorAll('.category-btn');
if (categoryButtons.length > 0) {
    categoryButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const categoryId = e.target.getAttribute('data-category-id');
            const url = `/${categoryId}/category_posts`;
            
            // 新しいタブでURLを開く
            window.open(url, '_blank');
        });
    });
}

// const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// チャットセクション
const chatInput = document.querySelector('.chat-input textarea');
const sendChatBtn = document.querySelector('.chat-input span');
const chatbox = document.querySelector('.chatbox');

if (chatInput && sendChatBtn && chatbox) {
    let userMessage;
    const inputInitHeight = chatInput.scrollHeight;

    // ============================================================
    // 相談画面からの離脱検知
    // アカウントを複数人で共有する運用があるため、画面を離れた時点で
    // サーバー側の会話セッション（会話の文脈・相談ログの受付ID）を切る。
    // 次に開いた人の相談が前の人の続きとして記録されるのを防ぐ。
    // ============================================================
    // 非表示のまま放置された場合に会話を終了するまでの時間（ミリ秒）
    const HIDDEN_TIMEOUT_MS = 5 * 60 * 1000;
    let hiddenTimer = null;
    let chatSessionEnded = false;

    const endChatSession = () => {
        if (chatSessionEnded) return;
        chatSessionEnded = true;
        // 離脱時はfetchが中断されることがあるためsendBeaconを使う
        if (navigator.sendBeacon) {
            navigator.sendBeacon('/end-chat-session', new Blob([], { type: 'text/plain' }));
        } else {
            fetch('/end-chat-session', { method: 'POST', keepalive: true }).catch(() => {});
        }
    };

    // タブを閉じる・別ページへ遷移・リロード → 即座に終了
    window.addEventListener('pagehide', endChatSession);

    // 一時的なタブ切り替えで会話が分断されないよう、非表示が続いた場合のみ終了する
    // （pagehideが発火しないモバイルのバックグラウンド遷移への保険）
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            hiddenTimer = setTimeout(endChatSession, HIDDEN_TIMEOUT_MS);
        } else {
            clearTimeout(hiddenTimer);
            hiddenTimer = null;
        }
    });

    // 画面に戻ってきた場合は、次の離脱で再度終了できるようフラグを戻す
    window.addEventListener('pageshow', () => {
        chatSessionEnded = false;
    });

    // createChatLi関数は既存コードのまま
    const createChatLi = (message, className) => {
        const chatLi = document.createElement('li');
        chatLi.classList.add('chat', className);
        let chatContent = className === "outgoing" ? `<p></p>` : `<span class="material-symbols-outlined">smart_toy</span><p></p>`;
        chatLi.innerHTML = chatContent;
        chatLi.querySelector('p').textContent = message;
        return chatLi;
    }

    // 新しい相談ボタン追加関数 - チャットセクション内に移動
    function addNewChatButton() {
        // チャットボックスのコンテナを取得
        const chatContainer = document.querySelector('.chatbot');
        if (!chatContainer) return;
        
        // ボタンが既に存在する場合は追加しない
        if (document.getElementById('new-chat-button')) return;
        
        // ボタンコンテナを作成
        const buttonContainer = document.createElement('div');
        buttonContainer.style.cssText = 'text-align: right; padding: 5px 10px;';
        
        // 新しいチャットボタンを作成
        const newChatBtn = document.createElement('button');
        newChatBtn.id = 'new-chat-button';
        newChatBtn.textContent = '新しい相談を始める';
        newChatBtn.className = 'btn btn-outline-primary btn-sm';
        newChatBtn.style.marginRight = '5px';
        
        // ボタンのクリックイベント
        newChatBtn.addEventListener('click', function() {
            if (confirm('新しい相談を始めますか？現在の会話は終了します。')) {
                fetch('/start-new-chat', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    // チャットをクリアして初期メッセージを表示
                    chatbox.innerHTML = '';
                    // ここで内部スコープのcreateChatLi関数を使用できる
                    const incomingChatLi = createChatLi('こんにちは 👍 \n本日はどのようなことでお困りですか？\nDFSロボット君があなたのお悩みの相談をおうけ致します。', "incoming");
                    chatbox.appendChild(incomingChatLi);
                    // 相談を作り直したので、案内も出し直す
                    if (typeof showFollowUpCard === 'function') { showFollowUpCard(); }
                })
                .catch(error => {
                    console.error('Error starting new chat:', error);
                });
            }
        });
        
        // ボタンをコンテナに追加
        buttonContainer.appendChild(newChatBtn);
        
        // チャットボックスの適切な位置に挿入
        const categoryButtons = chatContainer.querySelector('.category-buttons');
        if (categoryButtons) {
            chatContainer.insertBefore(buttonContainer, categoryButtons);
        } else {
            chatContainer.insertBefore(buttonContainer, chatContainer.querySelector('.chat-input'));
        }
    }

    // const generateResponse = (incomingChatLi, message) => {
    //     const messageElement = incomingChatLi.querySelector('p');
        
    //     // 引数で受け取った値を優先、なければグローバル変数、それもなければエラー
    //     const currentMessage = message || window.lastUserMessage || userMessage;
        
    //     console.log('Sending message to API:', currentMessage);
        
    //     if (!currentMessage || !currentMessage.trim()) {
    //         messageElement.classList.add('error');
    //         messageElement.textContent = "送信するメッセージが見つかりません。";
    //         return;
    //     }
        
    //     fetch('/get-response', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify({ message: currentMessage.trim() })
    //     })
    //     .then(response => response.json())
    //     .then(data => {
    //         // 改行を維持するように修正
    //         const message = data.message;
    //         messageElement.innerHTML = '';
    //         typeMessage(message, messageElement);
    //     })
    //     .catch((error) => {
    //         console.error('API Error:', error); // デバッグ情報追加
    //         messageElement.classList.add('error');
    //         messageElement.textContent = "一時的なエラーです。少し時間をあけてから、再度お試しください。";
    //     })
    //     .finally(() => chatbox.scrollTo(0, chatbox.scrollHeight));
    // }

    // ===== 人的フォローの依頼（フォーサーからの連絡希望） =====
    // ログインアカウントは複数人で共有されている運用があり、相談者本人を特定できない。
    // 1回目の回答のあとに一度だけ、連絡先の入力を案内する。
    // 入力は任意で、閉じてもAI相談はそのまま続けられる。
    //
    // 【表示上の注意】
    // 吹き出しの <p> は white-space: pre-wrap のため、その中にカードを入れると
    // HTMLの字下げがそのまま表示されて崩れる。<p> の中に入力欄を置くのもHTML的に不正。
    // そのため吹き出しの外に独立した行として差し込み、空白の扱いも明示している。
    const FOLLOW_UP_STYLES = [
        '.follow-up-li { display: block; margin: 8px 0 20px 42px; }',
        '.follow-up-card {',
        '  white-space: normal;',
        '  max-width: 75%;',
        '  padding: 16px 18px;',
        '  border: 1px solid #dee2e6;',
        '  border-radius: 10px;',
        '  background: #fff;',
        '  color: #212529;',
        '  box-shadow: 0 1px 2px rgba(16,24,40,.04);',
        '}',
        '.follow-up-card .fu-title { font-size: .95rem; font-weight: 600; margin-bottom: 6px; }',
        '.follow-up-card .fu-lead { font-size: .85rem; color: #495057; line-height: 1.7; margin-bottom: 14px; }',
        '.follow-up-card .fu-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 8px; }',
        '.follow-up-card .fu-grid.fu-one { grid-template-columns: 1fr; }',
        '.follow-up-card label { display: block; font-size: .75rem; color: #6c757d; margin-bottom: 3px; }',
        '.follow-up-card input, .follow-up-card select {',
        '  width: 100%; box-sizing: border-box; padding: 7px 10px;',
        '  border: 1px solid #ced4da; border-radius: 6px;',
        '  font-size: .875rem; font-family: inherit; color: #212529; background: #fff;',
        '}',
        '.follow-up-card input:focus, .follow-up-card select:focus { outline: none; border-color: #a78bfa; box-shadow: 0 0 0 3px rgba(114,74,232,.12); }',
        '.follow-up-card .fu-actions { display: flex; gap: 10px; align-items: center; margin-top: 14px; }',
        '.follow-up-card button { padding: 7px 18px; border-radius: 6px; font-size: .875rem; cursor: pointer; font-family: inherit; }',
        '.follow-up-card .fu-send { background: #724ae8; color: #fff; border: 1px solid #724ae8; }',
        '.follow-up-card .fu-send:hover { background: #5f3ad4; }',
        '.follow-up-card .fu-send:disabled { opacity: .55; cursor: default; }',
        '.follow-up-card .fu-close { background: transparent; color: #6c757d; border: none; text-decoration: underline; padding: 7px 4px; }',
        '.follow-up-card .fu-help { font-size: .75rem; color: #868e96; line-height: 1.6; margin-top: 10px; }',
        '.follow-up-card .fu-error { font-size: .8rem; color: #dc3545; margin-top: 10px; }',
        '.follow-up-card .fu-remember { display: flex; align-items: flex-start; gap: 8px; margin: 14px 0 0; font-size: .8rem; color: #495057; line-height: 1.6; cursor: pointer; }',
        '.follow-up-card .fu-remember input { width: auto; flex: none; margin: 3px 0 0; }',
        '.follow-up-card .fu-remember .fu-caution { display: block; font-size: .72rem; color: #868e96; }',
        '.follow-up-card .fu-saved { font-size: .75rem; color: #495057; background: #f8f9fa; border-radius: 6px; padding: 8px 10px; margin-bottom: 12px; }',
        '.follow-up-card .fu-clear { background: none; border: none; color: #724ae8; text-decoration: underline; cursor: pointer; padding: 0 0 0 4px; font-size: .75rem; font-family: inherit; }',
        // 連絡先を送っただけでは相談は完了していない。完了の緑ではなく、
        // 「まだ途中」であることが伝わる色にする
        '.follow-up-card.is-pending { border-color: #f0b849; background: #fffbf0; }',
        '.follow-up-card .fu-notice {',
        '  background: #fff4d6; border: 1px solid #f0b849; border-radius: 8px;',
        '  padding: 10px 12px; margin-bottom: 12px;',
        '  font-size: .875rem; line-height: 1.7; color: #7a4f01;',
        '}',
        '.follow-up-card .fu-notice strong { display: block; font-size: .9rem; color: #8a5a00; }',
        '.follow-up-card .fu-arrow {',
        '  display: flex; align-items: center; justify-content: center; gap: 8px;',
        '  margin: 14px 0 4px; font-size: .875rem; font-weight: 600; color: #724ae8;',
        '}',
        '.follow-up-card .fu-arrow .fu-arrow-mark { font-size: 1.25rem; line-height: 1; animation: fuArrowBounce 1.4s ease-in-out 3; }',
        '@keyframes fuArrowBounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(4px); } }',
        '@media (prefers-reduced-motion: reduce) {',
        '  .follow-up-card .fu-arrow .fu-arrow-mark { animation: none; }',
        '}',
        // 受付IDは連絡先の控えでしかないため、完了番号に見えないよう控えめに置く
        '.follow-up-card .fu-receipt { font-size: .72rem; color: #adb5bd; margin-top: 12px; }',
        '@media (max-width: 640px) {',
        '  .follow-up-li { margin-left: 0; }',
        '  .follow-up-card { max-width: 100%; }',
        '  .follow-up-card .fu-grid { grid-template-columns: 1fr; }',
        '}'
    ].join('\n');
    const followUpStyleEl = document.createElement('style');
    followUpStyleEl.textContent = FOLLOW_UP_STYLES;
    document.head.appendChild(followUpStyleEl);


    // 字下げがそのまま出ないよう、HTMLは行頭の空白なしで組み立てる
    const FOLLOW_UP_HTML = [
        '<div class="fu-title">担当者からのご案内をご希望ですか？</div>',
        '<div class="fu-lead">AI相談に加えて、DFSの担当者から直接ご案内・フォローをいたします。',
        'ご希望の場合は、ご相談を始める前にご連絡先をお知らせください。',
        'ご不要な場合は、そのまま下の入力欄からご相談内容をご入力ください。</div>',
        '<div class="fu-saved" style="display:none;">この端末に保存した内容を表示しています。'
        + '<button type="button" class="fu-clear">保存した内容を消す</button></div>',
        '<div class="fu-grid">',
        '<div><label>姓（任意）</label><input type="text" class="fu-last" autocomplete="family-name"></div>',
        '<div><label>名（任意）</label><input type="text" class="fu-first" autocomplete="given-name"></div>',
        '</div>',
        '<div class="fu-grid">',
        '<div><label>年齢（任意）</label><input type="number" class="fu-age" min="0" max="120" inputmode="numeric"></div>',
        '<div><label>性別（任意）</label><select class="fu-gender">',
        '<option value="">選択しない</option>',
        '<option value="male">男性</option>',
        '<option value="female">女性</option>',
        '<option value="other">その他</option>',
        '<option value="no_answer">回答しない</option>',
        '</select></div>',
        '</div>',
        '<div class="fu-grid">',
        '<div><label>メールアドレス</label><input type="email" class="fu-email" autocomplete="email" placeholder="example@example.com"></div>',
        '<div><label>電話番号</label><input type="tel" class="fu-phone" autocomplete="tel" placeholder="03-1234-5678"></div>',
        '</div>',
        '<div class="fu-grid fu-one">',
        '<div><label>ご希望・ご都合のよい連絡時間など（任意）</label><input type="text" class="fu-note"></div>',
        '</div>',
        '<label class="fu-remember"><input type="checkbox" class="fu-remember-on">'
        + '<span>この端末に保存して、次回から自動で入力する'
        + '<span class="fu-caution">共用の端末ではチェックしないでください。ご希望欄は保存しません。</span>'
        + '</span></label>',
        '<div class="fu-actions">',
        '<button type="button" class="fu-send">連絡先を送る</button>',
        '<button type="button" class="fu-close">閉じる</button>',
        '</div>',
        '<div class="fu-help">お名前は任意です。メールアドレスか電話番号のどちらかをご入力ください。</div>',
        '<div class="fu-error" style="display:none;"></div>'
    ].join('');
    // 連絡先をこの端末に覚えるかどうかは、ご本人に選んでいただく。
    // 1つのアカウントを別々の会社が共有する運用のため、端末を共用している方が
    // 前の方の連絡先を目にすることのないよう、既定では保存しない。
    const FOLLOW_UP_STORAGE_KEY = 'dfs.followUp.contact';
    const FOLLOW_UP_SAVED_FIELDS = ['last_name', 'first_name', 'age', 'gender', 'email', 'phone'];

    function loadSavedContact() {
        // 保存が禁止されている設定や、壊れた値が入っていた場合は「なし」として扱う
        try {
            const raw = localStorage.getItem(FOLLOW_UP_STORAGE_KEY);
            if (!raw) return null;
            const data = JSON.parse(raw);
            if (!data || typeof data !== 'object') return null;
            const saved = {};
            FOLLOW_UP_SAVED_FIELDS.forEach((key) => {
                if (typeof data[key] === 'string' && data[key]) saved[key] = data[key];
            });
            return Object.keys(saved).length ? saved : null;
        } catch (e) {
            return null;
        }
    }

    function saveContact(payload) {
        // ご希望欄は相談ごとに変わるため覚えない
        try {
            const saved = {};
            FOLLOW_UP_SAVED_FIELDS.forEach((key) => {
                const value = (payload[key] || '').trim();
                if (value) saved[key] = value;
            });
            if (!Object.keys(saved).length) { clearSavedContact(); return; }
            localStorage.setItem(FOLLOW_UP_STORAGE_KEY, JSON.stringify(saved));
        } catch (e) {
            // 保存できないだけで、相談はそのまま続けられる
        }
    }

    function clearSavedContact() {
        try {
            localStorage.removeItem(FOLLOW_UP_STORAGE_KEY);
        } catch (e) {
            // 消せなくても画面の動きは変えない
        }
    }

    function buildFollowUpCard() {
        const card = document.createElement('div');
        card.className = 'follow-up-card';
        card.innerHTML = FOLLOW_UP_HTML;
        const errorEl = card.querySelector('.fu-error');
        const sendBtn = card.querySelector('.fu-send');
        const val = (cls) => card.querySelector(cls).value;
        const rememberEl = card.querySelector('.fu-remember-on');
        const savedEl = card.querySelector('.fu-saved');
        const CONTACT_FIELDS = {
            '.fu-last': 'last_name', '.fu-first': 'first_name', '.fu-age': 'age',
            '.fu-gender': 'gender', '.fu-email': 'email', '.fu-phone': 'phone'
        };
        const saved = loadSavedContact();
        if (saved) {
            // 前回この端末に保存された内容を入れ、保存中であることを画面にも示す
            Object.keys(CONTACT_FIELDS).forEach((cls) => {
                const value = saved[CONTACT_FIELDS[cls]];
                if (value) card.querySelector(cls).value = value;
            });
            rememberEl.checked = true;
            savedEl.style.display = 'block';
        }
        card.querySelector('.fu-clear').addEventListener('click', () => {
            clearSavedContact();
            Object.keys(CONTACT_FIELDS).forEach((cls) => { card.querySelector(cls).value = ''; });
            rememberEl.checked = false;
            savedEl.style.display = 'none';
        });
        card.querySelector('.fu-close').addEventListener('click', () => {
            const row = card.closest('.follow-up-li');
            if (row) { row.remove(); } else { card.remove(); }
        });
        sendBtn.addEventListener('click', () => {
            const payload = {
                last_name: val('.fu-last'),
                first_name: val('.fu-first'),
                age: val('.fu-age'),
                gender: val('.fu-gender'),
                email: val('.fu-email'),
                phone: val('.fu-phone'),
                note: val('.fu-note')
            };
            if (!payload.email.trim() && !payload.phone.trim()) {
                errorEl.textContent = 'メールアドレスか電話番号のどちらかをご入力ください。';
                errorEl.style.display = 'block';
                return;
            }
            errorEl.style.display = 'none';
            sendBtn.disabled = true;
            sendBtn.textContent = '送信中…';
            const token = document.querySelector('meta[name="csrf-token"]');
            fetch('/chat/follow-up', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': token ? token.getAttribute('content') : ''
                },
                body: JSON.stringify(payload)
            })
            // ログイン切れやトークン失効ではHTMLが返ることがある。
            // そのままJSONとして読むと解析エラーの文言が出てしまい、
            // 送れていない理由が相談者に伝わらないため、読めない場合は空として扱う
            .then(res => res.json()
                .catch(() => ({}))
                .then(data => ({ ok: res.ok, status: res.status, data: data || {} })))
            .then(({ ok, status, data }) => {
                if (status === 401) {
                    throw new Error(data.message
                        || 'ログインの有効期限が切れました。画面を再読み込みのうえ、ログインし直してください。');
                }
                if (!ok || !data.ok) {
                    throw new Error(data.message
                        || '受付に失敗しました。お手数ですが画面を再読み込みのうえ、もう一度お試しください。');
                }
                if (rememberEl.checked) { saveContact(payload); } else { clearSavedContact(); }
                // 受け付けたのは連絡先だけで、相談はまだ始まっていない。
                // 「送信完了」と受け取られると相談内容が届かないまま終わってしまうため、
                // 未送信であることを最初に伝え、受付IDは控えとして最後に小さく置く。
                card.classList.add('is-pending');
                card.innerHTML = [
                    '<div class="fu-title">ご連絡先を承りました</div>',
                    '<div class="fu-notice">',
                    '<strong>ご相談内容は、まだ送信されていません。</strong>',
                    'お受けしたのはご連絡先のみです。',
                    'お困りの内容は、この下の入力欄からお送りください。</div>',
                    '<div class="fu-lead">いただいた内容を確認したうえで、',
                    '担当者より改めてフォローのご連絡をいたします。</div>',
                    '<div class="fu-arrow"><span class="fu-arrow-mark">&#x2193;</span>',
                    '<span>下の入力欄にご相談内容をご入力ください</span></div>',
                    '<div class="fu-receipt">ご連絡先の受付ID：',
                    data.receipt_id,
                    '</div>'
                ].join('');
                // 入力欄にカーソルを移し、次に何をすればよいかを画面上でも示す
                if (chatInput) { chatInput.focus(); }
            })
            .catch(err => {
                sendBtn.disabled = false;
                sendBtn.textContent = '連絡先を送る';
                errorEl.textContent = err.message || '受付に失敗しました。時間をおいてお試しください。';
                errorEl.style.display = 'block';
            })
            .finally(() => chatbox.scrollTo(0, chatbox.scrollHeight));
        });
        return card;
    }
    function showFollowUpCard() {
        // 相談を始める前の初期表示として、あいさつの下に置く。
        // 入力は任意で、そのままAI相談を続けられる。
        if (!chatbox || chatbox.querySelector('.follow-up-li')) return;
        const row = document.createElement('li');
        row.className = 'follow-up-li';
        row.appendChild(buildFollowUpCard());
        chatbox.appendChild(row);
    }

    // 画面を開いた時点で案内を出す
    showFollowUpCard();

    const generateResponse = (incomingChatLi, message) => {
        const messageElement = incomingChatLi.querySelector('p');
        
        const currentMessage = message || window.lastUserMessage || userMessage;
        
        if (!currentMessage || !currentMessage.trim()) {
            messageElement.classList.add('error');
            messageElement.textContent = "送信するメッセージが見つかりません。";
            return;
        }
        
        // ストリーミング版を使用
        fetch('/get-response-streaming', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message: currentMessage.trim() })
        })
        .then(response => {
            // セッション切れ（未ログイン）は原因が分かるように専用の案内を出す
            if (response.status === 401) {
                messageElement.classList.add('error');
                messageElement.innerHTML =
                    '<span style="color: #dc3545;">ログインの有効期限が切れました。'
                    + '<a href="/login">こちら</a>から再度ログインしてください。</span>';
                return;
            }
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let fullResponse = '';
            
            // 初期状態をクリア
            messageElement.innerHTML = '';
            
            function readStream() {
                return reader.read().then(({ done, value }) => {
                    if (done) {
                        // ストリーミング完了
                        chatbox.scrollTo(0, chatbox.scrollHeight);
                        return;
                    }

                    const chunk = decoder.decode(value, { stream: true });
                    const lines = chunk.split('\n');
                    
                    for (const line of lines) {
                        if (line.startsWith('data: ')) {
                            try {
                                const data = JSON.parse(line.substring(6));
                                
                                if (data.type === 'status') {
                                    // 進行状況を表示
                                    messageElement.innerHTML = `<div class="status-message" style="color: #007bff; font-style: italic;">${data.message}</div>`;
                                    chatbox.scrollTo(0, chatbox.scrollHeight);
                                    
                                } else if (data.type === 'chunk' && data.content) {
                                    // 最初のチャンクでステータスメッセージをクリア
                                    if (messageElement.querySelector('.status-message')) {
                                        messageElement.innerHTML = '';
                                        fullResponse = '';
                                    }
                                    
                                    // チャンクを追加
                                    fullResponse += data.content;
                                    messageElement.innerHTML = fullResponse.replace(/\n/g, '<br>');
                                    chatbox.scrollTo(0, chatbox.scrollHeight);
                                    
                                } else if (data.type === 'complete') {
                                    // 完了情報を表示（オプション）
                                    if (data.response_time && data.used_docs) {
                                        const infoDiv = document.createElement('div');
                                        infoDiv.style.cssText = 'margin-top: 10px; font-size: 0.8em; color: #6c757d; border-top: 1px solid #eee; padding-top: 5px;';
                                        // infoDiv.innerHTML = `参考事例: ${data.used_docs}件 | 処理時間: ${data.response_time}秒`;
                                        messageElement.appendChild(infoDiv);
                                    }
                                    
                                } else if (data.type === 'error') {
                                    // エラー表示
                                    messageElement.classList.add('error');
                                    messageElement.innerHTML = `<span style="color: #dc3545;">${data.message}</span>`;
                                }
                            } catch (e) {
                                console.error('JSON parse error:', e);
                            }
                        }
                    }
                    
                    return readStream();
                });
            }
            
            return readStream();
        })
        .catch((error) => {
            console.error('Streaming Error:', error);
            messageElement.classList.add('error');
            messageElement.innerHTML = '<span style="color: #dc3545;">一時的なエラーです。少し時間をあけてから、再度お試しください。</span>';
        })
        .finally(() => {
            chatbox.scrollTo(0, chatbox.scrollHeight);
        });
    }

    // 通常版とストリーミング版を切り替えるオプション（デバッグ用）
    function generateResponseNormal(incomingChatLi, message) {
        // 既存の非ストリーミング版
        const messageElement = incomingChatLi.querySelector('p');
        const currentMessage = message || window.lastUserMessage || userMessage;
        
        if (!currentMessage) {
            messageElement.textContent = "メッセージエラー";
            return;
        }
        
        fetch('/get-response', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message: currentMessage.trim() })
        })
        .then(response => response.json())
        .then(data => {
            messageElement.innerHTML = '';
            typeMessage(data.message, messageElement);
        })
        .catch((error) => {
            messageElement.classList.add('error');
            messageElement.textContent = "一時的なエラーです。少し時間をあけてから、再度お試しください。";
        });
    }

    // CSS追加（進行状況表示用）
    const streamingStyles = document.createElement('style');
    streamingStyles.textContent = `
    .status-message {
        padding: 8px 12px;
        background: linear-gradient(90deg, #e3f2fd 0%, #f3e5f5 100%);
        border-radius: 20px;
        display: inline-block;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
    }

    .error {
        color: #dc3545 !important;
    }
    `;
    document.head.appendChild(streamingStyles);

    // タイピングアニメーション関数を改良して改行に対応
    const typeMessage = (message, messageElement) => {
        let formattedMessage = message.replace(/\n/g, "<br>");
        let index = 0;
        let html = '';

        const interval = setInterval(() => {
            if (index < formattedMessage.length) {
                // <br>タグをまとめて処理
                if (formattedMessage.substring(index, index + 4) === "<br>") {
                    html += "<br>";
                    index += 4;
                } else {
                    html += formattedMessage.charAt(index);
                    index++;
                }
                messageElement.innerHTML = html;
            } else {
                clearInterval(interval);
            }
            // タイピング中も自動スクロール
            chatbox.scrollTo(0, chatbox.scrollHeight);
        }, 20); // タイピング速度を少し速く
    };

    const handleChat = () => {
        userMessage = chatInput.value.trim();
        if (!userMessage) return;
        
        // グローバル変数として保存（generateResponseでアクセス可能に）
        window.lastUserMessage = userMessage;
        
        chatInput.value = "";
        chatbox.appendChild(createChatLi(userMessage, "outgoing"));
        chatbox.scrollTop = chatbox.scrollHeight;
        setTimeout(() => {
            const incomingChatLi = createChatLi("考え中...", "incoming")
            chatbox.appendChild(incomingChatLi);
            generateResponse(incomingChatLi, userMessage); // 引数として渡す
        }, 600);
    }

    chatInput.addEventListener('input', () => {
        chatInput.style.height = `${inputInitHeight}px`;
        chatInput.style.height = `${chatInput.scrollHeight}px`;
    });

    // Enterで送るかどうかは、画面の広さではなくキーボードの有無で決める。
    // 幅で判定すると、パソコンでウィンドウを狭くしている方はEnterを押しても
    // 改行されるだけになり、送ったつもりで相談が届かないことがある。
    // タッチ操作の端末では、これまでどおりEnterは改行のままにする。
    const hasPhysicalKeyboard = () => {
        if (!window.matchMedia) return true;
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    };

    chatInput.addEventListener('keydown', (e) => {
        // 日本語入力の変換中に押されたEnterは、確定の操作なので送信しない
        if (e.isComposing || e.keyCode === 229) return;
        if (e.key === "Enter" && !e.shiftKey && hasPhysicalKeyboard()) {
            e.preventDefault();
            handleChat();
        }
    });

    sendChatBtn.addEventListener('click', handleChat);
    // 送信ボタンは <span> のため、キーボード操作だけでは押せない。role="button" に合わせて補う
    sendChatBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleChat();
        }
    });
    
    // ボタンを追加する（既存のコードブロック内）
    addNewChatButton();
}

//カテゴリーボタンクリック計測用
document.addEventListener('DOMContentLoaded', function() {
    // const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
    const categoryButtons = document.querySelectorAll('.category-buttons .category-btn');

    if (categoryButtons.length > 0) {//csrfTokenMeta &&

        // const csrfToken = csrfTokenMeta.getAttribute('content');

        categoryButtons.forEach(button => {
            button.addEventListener('click', function() {
                const categoryId = this.dataset.categoryId;
                const category = this.dataset.category;
                
                fetch('/api/category-click', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 'X-CSRFToken': csrfToken,
                        // 'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({ 
                        categoryId,
                        category
                    }),
                })
                .then(response => response.json())
                .then(data => console.log('Category click recorded:', data))
                .catch((error) => console.error('Error:', error));
            });
        });
    } else {
        console.log('Required elements not found. CSRF token or category buttons may be missing.');
    }
});

// script.js に以下を追加（既存コードは変更しない）

// テスト用の送信ボタンを追加する関数
// function addTestRAGButton() {
//     const chatContainer = document.querySelector('.chatbot');
//     if (!chatContainer) return;
    
//     // ボタンがすでに存在する場合は追加しない
//     if (document.getElementById('test-rag-button')) return;
    
//     const buttonContainer = document.createElement('div');
//     buttonContainer.style.cssText = 'text-align: center; padding: 10px; border-top: 1px solid #ddd;';
    
//     const testButton = document.createElement('button');
//     testButton.id = 'test-rag-button';
//     testButton.textContent = 'BlogPost RAGテスト';
//     testButton.className = 'btn btn-outline-success btn-sm';
//     testButton.style.marginRight = '10px';
    
//     // 状態表示用の要素
//     const statusDiv = document.createElement('div');
//     statusDiv.id = 'test-rag-status';
//     statusDiv.style.cssText = 'margin-top: 10px; font-size: 0.9em; color: #666;';
    
//     // テストボタンのクリックイベント
//     testButton.addEventListener('click', function() {
//         const currentMessage = document.getElementById('messageInput') ? 
//                              document.getElementById('messageInput').value : 
//                              document.querySelector('.chat-input textarea').value;
        
//         if (!currentMessage.trim()) {
//             alert('まずメッセージを入力してください');
//             return;
//         }
        
//         testBlogPostRAG(currentMessage);
//     });
    
//     buttonContainer.appendChild(testButton);
//     buttonContainer.appendChild(statusDiv);
    
//     // チャット入力の上に配置
//     const chatInput = chatContainer.querySelector('.chat-input');
//     if (chatInput) {
//         chatContainer.insertBefore(buttonContainer, chatInput);
//     }
// }

// // BlogPost RAGをテストする関数
// function testBlogPostRAG(message) {
//     const statusDiv = document.getElementById('test-rag-status');
//     const testButton = document.getElementById('test-rag-button');
    
//     // ボタンを無効化して状態を表示
//     testButton.disabled = true;
//     testButton.textContent = 'テスト実行中...';
//     statusDiv.innerHTML = '<i class="fas fa-spinner fa-spin"></i> BlogPost RAGテスト実行中...';
    
//     fetch('/test-blogpost-rag', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ message: message })
//     })
//     .then(response => response.json())
//     .then(data => {
//         // テスト結果を表示
//         let statusHTML = `<div style="padding: 10px; background: #f8f9fa; border-radius: 5px; margin-top: 5px;">`;
//         statusHTML += `<strong>🧪 テスト結果:</strong><br>`;
//         statusHTML += `📄 参照ソース: ${data.source}<br>`;
        
//         if (data.used_documents) {
//             statusHTML += `📊 使用文書数: ${data.used_documents}/${data.total_documents}<br>`;
//         }
        
//         if (data.blogpost_docs) {
//             statusHTML += `📚 BlogPost文書数: ${data.blogpost_docs}<br>`;
//         }
        
//         if (data.document_titles && data.document_titles.length > 0) {
//             statusHTML += `📋 参照記事:<br>`;
//             data.document_titles.forEach(title => {
//                 statusHTML += `　• ${title}<br>`;
//             });
//         }
        
//         statusHTML += `</div>`;
        
//         statusDiv.innerHTML = statusHTML;
        
//         // チャットにテスト結果を表示
//         if (typeof createChatLi === 'function' && chatbox) {
//             const testResultLi = createChatLi(`🧪 BlogPost RAGテスト結果:\n\n${data.message}`, "incoming");
//             chatbox.appendChild(testResultLi);
//             chatbox.scrollTo(0, chatbox.scrollHeight);
//         }
        
//     })
//     .catch(error => {
//         console.error('Test RAG Error:', error);
//         statusDiv.innerHTML = `<div style="color: #dc3545;">❌ テストエラー: ${error}</div>`;
//     })
//     .finally(() => {
//         // ボタンを再有効化
//         testButton.disabled = false;
//         testButton.textContent = 'BlogPost RAGテスト';
//     });
// }

// // ページ読み込み時にテストボタンを追加
// document.addEventListener('DOMContentLoaded', function() {
//     // 少し遅延してボタンを追加（他の初期化処理の後）
//     setTimeout(addTestRAGButton, 1000);
// });

// // 既存のチャット機能がある場合にも追加
// if (typeof addNewChatButton === 'function') {
//     // 既存のaddNewChatButton関数が実行された後に追加
//     setTimeout(addTestRAGButton, 1500);
// }